import React from "react";
import { motion, AnimatePresence } from "framer-motion";

const BlindRender = ({
  renderValance,
  renderHem,
  renderFabric,
  adjustHeight = false,
  adjustWidth = false,
  sm = false,
  isCellular = false,
  isVerticalSheer = false,
}) => {
  // Animation variants
  const imageVariants = {
    initial: { opacity: 0 },
    animate: { opacity: 1 },
    exit: { opacity: 0 },
  };
  // Common image props
  const commonImageProps = {
    className:
      "absolute inset-0 w-full h-full object-cover transition-all duration-300",
  };
  const containerClass = `
    relative overflow-hidden bg-white
    ${adjustHeight ? "h-[10vh]" : "h-full"}
    ${adjustWidth ? (sm ? "w-[15vh]" : "w-[18vh]") : "w-full"}
    ${adjustHeight ? "cartscreen max-w-full m-auto p-2" : ""}
    shadow-lg rounded-md
  `;

  return (
    <div className={containerClass}>
      <div className="relative w-full h-full">
        <AnimatePresence mode="wait">
          {isVerticalSheer ? (
            <motion.div
              key="vertical-sheer"
              initial="initial"
              animate="animate"
              exit="exit"
              variants={imageVariants}
              className="relative aspect-square"
            >
              <img
                className="absolute inset-0 w-full h-full object-cover transition-all duration-300"
                src="/images/newHome/shades/vertical_sheer.jpg"
                alt="Vertical Sheer"
                onError={(e) => {
                  e.target.src = "/images/render/empty.png";
                }}
              />
            </motion.div>
          ) : (
            <motion.div
              key="normal-render"
              initial="initial"
              animate="animate"
              exit="exit"
              variants={imageVariants}
              className="relative w-full h-full"
            >
              {/* Base Layer */}
              <motion.div
                initial="initial"
                animate="animate"
                exit="exit"
                variants={imageVariants}
                className="relative aspect-[3/4]"
              >
                <img
                  {...commonImageProps}
                  src="/images/render/render_base.png"
                  alt="Base"
                />
              </motion.div>

              {/* Fabric Layer */}
              <AnimatePresence mode="wait">
                <motion.div
                  key={renderFabric}
                  initial="initial"
                  animate="animate"
                  exit="exit"
                  variants={imageVariants}
                  className="absolute inset-0"
                >
                  <img
                    {...commonImageProps}
                    src={`/images/render/${renderFabric.toLowerCase()}/fabric.png`}
                    alt="Fabric"
                    onError={(e) => {
                      e.target.src =
                        "/images/render/silk%20opaque%20bright%20white/fabric.png";
                    }}
                  />
                </motion.div>
              </AnimatePresence>

              {/* Valance Layer */}
              {!isCellular && (
                <>
                  <AnimatePresence mode="wait">
                    <motion.div
                      key={renderValance}
                      initial="initial"
                      animate="animate"
                      exit="exit"
                      variants={imageVariants}
                      className="absolute inset-0"
                    >
                      <img
                        {...commonImageProps}
                        src={`/images/${renderValance.toLowerCase()}`}
                        alt="Valance"
                        onError={(e) => {
                          e.target.src = "/images/render/option/valance/or/or.png";
                        }}
                      />
                    </motion.div>
                  </AnimatePresence>

                  {/* Valance Insert Layer */}
                  <AnimatePresence mode="wait">
                    <motion.div
                      key={`insert-${renderValance}`}
                      initial="initial"
                      animate="animate"
                      exit="exit"
                      variants={imageVariants}
                      className="absolute inset-0"
                    >
                      <img
                        {...commonImageProps}
                        src={`/images/${renderValance.toLowerCase()}`}
                        alt="Valance Insert"
                        onError={(e) => {
                          e.target.src = "/images/render/empty.png";
                        }}
                      />
                    </motion.div>
                  </AnimatePresence>

                  {/* Hem Layer */}
                  <AnimatePresence mode="wait">
                    <motion.div
                      key={renderHem}
                      initial="initial"
                      animate="animate"
                      exit="exit"
                      variants={imageVariants}
                      className="absolute inset-0"
                    >
                      <img
                        {...commonImageProps}
                        src={`/images/render/hem/${renderHem.toLowerCase()}.png`}
                        alt="Hem"
                        onError={(e) => {
                          e.target.src = "/images/render/option/hem/ph.png";
                        }}
                      />
                    </motion.div>
                  </AnimatePresence>

                  {/* Hem Insert Layer */}
                  <AnimatePresence mode="wait">
                    <motion.div
                      key={`insert-${renderHem}`}
                      initial="initial"
                      animate="animate"
                      exit="exit"
                      variants={imageVariants}
                      className="absolute inset-0"
                    >
                      <img
                        {...commonImageProps}
                        src={`/images/render/hem/${renderHem.toLowerCase()}.png`}
                        alt="Hem Insert"
                        onError={(e) => {
                          e.target.src = "/images/render/empty.png";
                        }}
                      />
                    </motion.div>
                  </AnimatePresence>
                </>
              )}

              {/* Overlay gradient for depth */}
              <div className="absolute inset-0 bg-gradient-to-t from-black/5 to-transparent pointer-events-none" />
            </motion.div>
          )}
        </AnimatePresence>
      </div>
    </div>
  );
};

export default BlindRender;
